// extracted by mini-css-extract-plugin
module.exports = {"slide":"ListItem_slide_1ygww","slide-reverse":"ListItem_slide-reverse_Dxoh2","config":"ListItem_config_3lFvY"};